<div class="plate-compare" *ngIf="badge || cropStyle">
  <!-- stored plate (this is what gets transferred to mandate / VSTV) -->
  <div class="plate-stored" *ngIf="badge">
    <div class="plate-caption">Gespeichertes Kennzeichen</div>
    <div class="plate-badge">
      <div class="plate-eu">
        <span class="plate-eu-country">{{ badge.country }}</span>
      </div>
      <div class="plate-body">
        <span class="plate-district" *ngIf="badge.district">{{ badge.district }}</span>
        <span class="plate-sep" *ngIf="badge.district">&middot;</span>
        <span class="plate-number">{{ badge.number }}</span>
      </div>
    </div>
  </div>

  <!-- cropped plate from the recognition image, shown next to the stored plate -->
  <div class="plate-preview" *ngIf="cropStyle">
    <div
      class="plate-image"
      [ngStyle]="cropStyle"
      [attr.aria-label]="'Erkanntes Kennzeichen ' + detectedPlate"></div>
  </div>
</div>
